export default "__VITE_ASSET__BnhOP0RG__"